import EmailIcon from 'components/ReusableComponents/Icons/Email'
import SmsIcon from 'components/ReusableComponents/Icons/Sms'
import useClickOut from 'hooks/useClickOut'
import { useRef, useState } from 'react'

import styles from './ComposeControls.module.scss'

const ComposeControls = ({ medium, setMedium }) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false)

  function handleButtonClick(e) {
    e.preventDefault()
    setIsDialogVisible(true)
  }

  const dialogRef = useRef()

  useClickOut(dialogRef, () => {
    setIsDialogVisible(false)
  })

  function selectOption(option) {
    if (option === medium) {
      setIsDialogVisible(false)
    } else {
      setMedium(option)
      setIsDialogVisible(false)
    }
  }

  return (
    <div className={styles.controlButton}>
      {isDialogVisible && (
        <div className={styles.dialog} ref={dialogRef}>
          <button
            className={styles.dialogButton}
            onClick={e => {
              e.preventDefault()
              selectOption('sms')
            }}
          >
            <div className={styles.dialogButtonImageHolder}>
              <SmsIcon width={32} height={32} />
            </div>
            Text message
          </button>
          <button
            className={styles.dialogButton}
            onClick={e => {
              e.preventDefault()
              selectOption('email')
            }}
          >
            <div className={styles.dialogButtonImageHolder}>
              <EmailIcon width={21} height={21} />
            </div>
            Email
          </button>
        </div>
      )}
      <button onClick={handleButtonClick} className={styles.controlButtonInner}>
        {medium === 'sms' ? (
          <SmsIcon width={32} height={32} className={styles.smsIcon} />
        ) : (
          <EmailIcon width={21} height={21} className={styles.emailIcon} />
        )}
      </button>
    </div>
  )
}

export default ComposeControls
